
/**
 * Copyright (c) 2024, Mint Metrics Pty Ltd All rights reserved. BSD 3-Clause License. https://github.com/mint-metrics/mojito/blob/master/LICENSE
 * Copyright (c) 2010, James Yu. https://github.com/jamesyu/cohorts/blob/master/LICENSE
 * Copyright (c) 2005-2017, JS Foundation All rights reserved. https://dojotoolkit.org/license.html
 * Copyright (c) 2011 Sebastian Tschan, https://blueimp.net
 */
(function () {
    function removeNode(node) {
        if (!node) return;
        if (node.remove) node.remove();
        else node.parentNode.removeChild(node);
    }

    function debounce(fn, delay = 20) {
        let timer;
        return function (event) {
            if (timer) clearTimeout(timer);
            timer = setTimeout(fn, delay, event);
        };
    }

    function shared(mediaObject) {
        document.documentElement.classList.add('w9');

        let videoLink, videoPopup, surveyPopup;

        function createVideoLink() {
            Mojito.utils.observeSelector(
                '#shopify-section-product-template div[data-product-images]',
                function (element) {
                    if (element.querySelector('.video-link')) return;

                    videoLink = document.createElement('div');
                    videoLink.className = 'video-link thumb';
                    videoLink.textContent = 'Play video';

                    element.insertAdjacentElement('afterbegin', videoLink);
                    videoLink.addEventListener('click', function () {
                        if (mediaObject) {
                            showVideoPopup();
                        } else {
                            // showSurveyPopup();
                        }
                    });
                }
            );


        }

        function createVideoPopup() {
            videoPopup = document.createElement('div');
            videoPopup.className = 'popup video';
            videoPopup.innerHTML =
                '<div class="content">\
                    <div class="close">&times;</div>\
                    <div class="video-holder"></div>\
                </div>';
            document.body.appendChild(videoPopup);

            videoPopup.addEventListener('click', function (e) {
                if (e.target === videoPopup || e.target.classList.contains('close')) {
                    hideVideoPopup();
                }
            });

            window.addEventListener('resize', debounce(setVideoSize));
        }

        function setVideoSize() {
            if (!videoPopup) return;

            const frame = videoPopup.querySelector('iframe');
            if (!frame) return;

            const ratio = mediaObject.aspect_ratio;
            const width = videoPopup.querySelector('.content').clientWidth;
            const height = Math.floor(width / ratio);

            frame.width = width;
            frame.height = height;
        }

        function showVideoPopup() {
            videoPopup.style.display = 'block';
            setTimeout(() => {
                videoPopup.classList.add('show');
                const videoId = mediaObject.external_id;
                const ratio = mediaObject.aspect_ratio;
                const width = videoPopup.querySelector('.content').clientWidth;
                const height = Math.floor(width / ratio);

                videoPopup.querySelector('.video-holder').innerHTML =
                    `<iframe width="${width}" height="${height}" src="https://www.youtube.com/embed/${videoId}?autoplay=1" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`;
            });
        }

        function hideVideoPopup() {
            videoPopup.classList.remove('show');
            setTimeout(() => {
                videoPopup.style.display = 'none';
                videoPopup.querySelector('.video-holder').innerHTML = '';
            }, 300);
        }

        function createSurveyPopup() {
            surveyPopup = document.createElement('div');
            surveyPopup.className = 'popup survey';
            surveyPopup.innerHTML =
                '<div class="content">\
                    <div class="close">&times;</div>\
                    <div class="survey-holder">\
                        <h3>Thanks for your interest</h3>\
                        <p>Sorry, we don’t have a video for this item yet, but we’re considering making one.</p>\
                        <h4>How likely would a video for this product help you decide?</h4>\
                        <div class="item-holder">\
                            <div class="line"></div>\
                            <label class="item">\
                                <input type="radio" name="survey" value="Very unlikely">\
                                <span class="checkmark"></span>\
                                <span>Very unlikely</span>\
                            </label>\
                            <label class="item">\
                                <input type="radio" name="survey" value="Somewhat unlikely">\
                                <span class="checkmark"></span>\
                                <span>Somewhat unlikely</span>\
                            </label>\
                            <label class="item">\
                                <input type="radio" name="survey" value="Neither likely or unlikely">\
                                <span class="checkmark"></span>\
                                <span>Neither likely or unlikely</span>\
                            </label>\
                            <label class="item">\
                                <input type="radio" name="survey" value="Somewhat likely">\
                                <span class="checkmark"></span>\
                                <span>Somewhat likely</span>\
                            </label>\
                            <label class="item">\
                                <input type="radio" name="survey" value="Very likely">\
                                <span class="checkmark"></span>\
                                <span>Very likely</span>\
                            </label>\
                        </div>\
                    </div>\
                </div>';
            document.body.appendChild(surveyPopup);

            surveyPopup.addEventListener('click', function (e) {
                if (e.target === surveyPopup || e.target.classList.contains('close')) {
                    hideSurveyPopup();
                }
            });

            surveyPopup.querySelector('.item-holder').addEventListener('click', function () {
                surveyPopup.classList.add('success');
                setTimeout(hideSurveyPopup, 4000);
            });
        }

        function showSurveyPopup() {
            surveyPopup.style.display = 'block';
            setTimeout(() => {
                surveyPopup.classList.add('show');
            });
        }

        function hideSurveyPopup() {
            surveyPopup.classList.remove('show');
            setTimeout(() => {
                surveyPopup.style.display = 'none';
            }, 300);
        }

        createVideoLink();
        if (mediaObject) {
            createVideoPopup();
        } else {
            // createSurveyPopup();
        }
    }

    function treatment(test) {
        Mojito.utils.waitUntil(
            function () {
                return (
                    window._BISConfig &&
                    window._BISConfig.product &&
                    window._BISConfig.product.media
                );
            },
            function () {
                let hasVideo = false;
                const medias = _BISConfig.product.media || [];
                let mediaObject;

                for (let i = medias.length - 1; i >= 0; i--) {
                    mediaObject = medias[i];
                    if (
                        mediaObject.media_type === 'external_video' &&
                        mediaObject.host === 'youtube' &&
                        mediaObject.external_id
                    ) {
                        hasVideo = true;
                        break;
                    }
                }

                Mojito.utils.domReady(function () {
                    if (hasVideo) {
                        shared(mediaObject);
                    } 
                });
            },
            30000
        );
    }

    function trigger() {
        if (/\/products\//gi.test(location.pathname)) {
            treatment({ options: { js: shared } });
        }
    }

    trigger();
})();
